import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import img from "../../../../../../assets/image/youtube.png";
import "./MiddleCard.css";

const MiddleCard3 = ({ newsItem, cart }) => {
    const { title, image, date_stamp, _id, youtube_embed, short_text } = newsItem;

      // Bengali date
      const dates = new Date(date_stamp);
      const options = { year: "numeric", month: "long", day: "numeric" };
      const dateInBengali = dates.toLocaleDateString("bn-IN", options);
      const [timeDifference, setTimeDifference] = useState("");
      useEffect(() => {
        const backendDate = new Date(date_stamp);

        const banglaDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

        const convertToBanglaDigits = (number) =>
          number
            .toString()
            .split("")
            .map((digit) => banglaDigits[parseInt(digit)])
            .join("");

        const calculateTimeDifference = () => {
          const now = new Date();
          const diff = now - backendDate;

          const seconds = Math.floor(diff / 1000);
          const minutes = Math.floor(seconds / 60);
          const hours = Math.floor(minutes / 60);
          const days = Math.floor(hours / 24);

          if (days < 10) {
            if (days > 0) return `${convertToBanglaDigits(days)} দিন আগে`;
            if (hours > 0) return `${convertToBanglaDigits(hours)} ঘন্টা আগে`;
            if (minutes > 0) return `${convertToBanglaDigits(minutes)} মিনিট আগে`;
            return `${convertToBanglaDigits(seconds)} সেকেন্ড আগে`;
          }
          return dateInBengali;
        };

        setTimeDifference(calculateTimeDifference());

        const interval = setInterval(() => {
          setTimeDifference(calculateTimeDifference());
        }, 60000);

        return () => clearInterval(interval);
      }, [date_stamp, dateInBengali]);
      const date = new Date(parseInt(_id));
      const moreButtonYear = date.getFullYear();

      const limitShortText = (text, maxLength) => {
        if (text.length <= maxLength) {
          return text;
        }
        return text.slice(0, maxLength) + "...";
      };
    return (
      <div className={`Forth${cart} border-b`}>
        <div className={`my-2 Border${cart}`}>
            <Link
              to={`/newsDetails/${_id}`}
              className="no-underline text-inherit"
            >
              <div className={`border3${cart} px-1`}>
                <div className="flex gap-3 items-start">
                  <figure className={`relative mx-auto px-3 overflow-hidden rounded-md flex-shrink-0 middleImageSection`}>
                    <img
                      src={`https://www.iskconbangla.com/img/${moreButtonYear}_news_sm/${image}`}
                      alt="news"
                      className="w-full h-full object-cover"
                    />

                    {youtube_embed && (
                      <img
                        src={img}
                        alt="YouTube"
                        className="w-8 h-8 absolute bottom-1 right-1"
                      />
                    )}
                  </figure>
                </div>
                <div className="mt-2 px-1" >
                 <h6 className=" font-semibold leading-snug text-[18px] text-black hover:text-blue-600">
                    {title}
                  </h6>
                  <p className="my-3 text-slate-700 text-md newsTitle">
                    {limitShortText(short_text, 100)}
                  </p>
                <p className="text-xs text-gray-500">{timeDifference}</p>
                  {/* <p className="text-xs text-gray-500">{cart}</p> */}
                </div>
              </div>
            </Link>
          </div>
          </div>
       
    );
};

export default MiddleCard3;